import { Provider } from '@angular/core';
import { provideCanvasDraft, provideCanvasEntityMapping } from '@panaya/ai-chat/canvas-draft';
import { provideCanvasForTool, provideCanvasFrame } from '@panaya/ai-chat/features';
import { GENERATE_TESTS_CANVAS_TOOL } from './generate-tests-canvas-tool';
import { TEST_CANVAS_ENTITY_MAPPING } from './test-canvas-entity-mapping';

/**
 * Everything the host registers for the Seemore canvas: the frame and the draft display family, then each agent's
 * canvas. An agent that brings its own canvas adds its `provideCanvasForTool` and, for a new entity type, its
 * `provideCanvasEntityMapping` here; tools and entity types are many-to-many (Generate from impact will reuse TM_TEST).
 */
export const seemoreCanvasProviders: Provider[] = [
    provideCanvasFrame(),
    // After provideCanvasFrame(): the draft interceptor must run after the frame interceptor.
    provideCanvasDraft(),
    // Generate Tests: the Test Builder's generate tool opens a `collection` canvas of TM_TEST drafts.
    provideCanvasForTool(GENERATE_TESTS_CANVAS_TOOL),
    provideCanvasEntityMapping('TM_TEST', TEST_CANVAS_ENTITY_MAPPING)
];
